import auth from './auth'
import usuario from './usuario'
import demarcacion from './demarcacion'
import dispositivo from './dispositivo'
import emergencia from './emergencias'
import icono from './icono'
import imagenEmergencia from './imagenEmergencia'
import imagenInfraestructura from './imagenInfraestructura'
import imagenSatelite from './imagenSatelite'
import incendio from './incendio'
import infraestructura from './infraestructura'
import organismo from './organismo'
import others from './others'
import parametro from './parametro'
import recurso from './recurso'
import recursoCategoria from './recursoCategoria'
import recursoClase from './recursoClase'
import recursoImagen from './recursoImagen'
import recursoRecursoTipo from './recursoRecursoTipo'
import recursoTipo from './recursoTipo'
import request from './request'
import ruta from './ruta'
import simulacion from './simulacion'
import tituloProfesional from './tituloProfesional'
import rol from './rol'
import permiso from './permiso'
import planificacion from './planificacion'
import appInfo from './appInfo'
import layers from './layer'
import baseMap from './baseMap'
import webmap from './webmap'
import geofencing from './geofencing'

export default {
  request,
  appInfo,
  auth,
  usuario,
  rol,
  permiso,
  planificacion,
  dispositivo,
  imagenEmergencia,
  imagenSatelite,
  incendio,
  recurso,
  parametro,
  infraestructura,
  simulacion,
  recursoRecursoTipo,
  recursoCategoria,
  imagenInfraestructura,
  demarcacion,
  recursoTipo,
  tituloProfesional,
  organismo,
  recursoImagen,
  emergencia,
  icono,
  recursoClase,
  ruta,
  layers,
  baseMap,
  webmap,
  others,
  geofencing
}
